import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss']
})
export class ManagementComponent implements OnInit {

  userRoles: string[];
  allRoles: any;

  constructor(
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    private keycloakService: KeycloakService,
    private titleService: Title
  ) {

  }

  ngOnInit() {
    if (this.titleService.getTitle().includes(" - ")) {
      this.titleService.setTitle(this.titleService.getTitle().split(" - ")[1]);
    }

    this.breadcrumbsService.sendBreadcrumbs({ breadcrumbs: [{ title: 'Administración', url: 'provision/management' }] });
    this.allRoles = Role;
    this.userRoles = this.keycloakService.getUserRoles();
  }

  public goToCatalogue(): void {
    this.router.navigate([`/provision/management/catalog`]);
  }

  public goToCoverage(): void {
    this.router.navigate([`/provision/management/coverage`]);
  }

  public goToTemplates(): void {
    this.router.navigate([`/provision/management/templates/search`]);
  }

  public goToServiceTemplates(): void {
    this.router.navigate([`/provision/management/serviceTemplates/search`]);
  }

  public goToResourcesLoad(): void {
    this.router.navigate([`/provision/management/ftthResourcesLoad`]);
  }

  public goToParty():void{
    this.router.navigate([`/provision/management/party`]);
  }

  public goToTaskManagement():void{
    this.router.navigate([`/provision/management/taskmanagement`])
  }

  public goToMasterData():void{
    this.router.navigate([`/provision/management/master-data`])
  }
  public goToPortOut():void{
    this.router.navigate([`/provision/management/port-out`]);
  }}
